module.exports = __webpack_public_path__ + "static/media/about2.196d5c02.png";